import axios from 'axios';
import actions from './actions';
import actionsAlert from '../alert/actions';
import { API_HOST, API } from '@configs/api';
import {
    isAdmin,
    isManager,
    setToken,
    setUserRole,
    getUser,
    removeToken,
    getUserId,
    getLoginStatus,
    isClient,
    isCandidate,
    isConsultant,
    setRefreshToken,
    getUserRoleLevel,
} from '@services/authentificationServices';
import { applyMissionPostulation } from '@store/candidature/actionCreator';
import jwtDecode from 'jwt-decode';
import { announcementApply } from '@store/candidature/actionCreator';
import securityModalActions from '@store/modals/security/actions';

const {
    userTypeToggle,
    loginSuccess,
    forgetPasswordAction,
    resetPasswordAction,
    sectors,
    jobsTypes,
    professions,
    locations,
    nationalities,
    workingPermission,
    agencesList,
    isAccountDisabled,
    reactivateAccount,
} = actions;
const { alert } = actionsAlert;
const { displaySecurityModal } = securityModalActions;

const setUserType = (identity) => {
    return (dispatch) => {
        if (identity === 0) {
            dispatch(userTypeToggle('candidate'));
        } else {
            dispatch(userTypeToggle('agency'));
        }
    };
};

const register = (data, dataLogin, missionId, title) => {
    const URL = API_HOST + API.auth.register;
    // Retrieve the email value from the FormData object
    var email = data.get('email');
    // save the email value
    localStorage.setItem('_mail_to_save', email);

    return async (dispatch) => {
        axios.post(URL, data).then(
            (res) => {
                if (res.data.code === 200) {
                    if (missionId) {
                        dispatch(announcementApply({ email }, missionId, title));
                    } else {
                        dispatch(
                            alert({
                                msg: 'success_register_user',
                                redirectLink: 'return_login_page',
                                type: 'success',
                            }),
                        );
                    }
                    localStorage.removeItem('cv');
                    localStorage.removeItem('jobsList');
                    localStorage.removeItem('birthdate');
                } else if (res.data.code === 400) {
                    dispatch(alert({ msg: 'email_exist', type: 'error' }));
                }
            },
            (err) => {
                dispatch(alert({ msg: 'error_register', type: 'error' }));
            },
        );
    };
};

const checkExistMail = (data, setErrorEmailExist) => {
    const URL = API_HOST + API.auth.checkExistMail;
    return async (dispatch) => {
        axios.post(URL, data).then(
            (res) => {
                setErrorEmailExist(true);
            },
            (err) => {
                setErrorEmailExist(false);
            },
        );
    };
};

/**
 * Check the email and return the result to the component.
 *
 * @param {*} email
 * @returns
 */
const checkEmail = (email) => async (dispatch) => {
    try {
        const URL = API_HOST + API.auth.checkExistMail;

        const response = await axios.post(URL, email);

        dispatch({ type: "CHECK_EMAIL_SUCCESS", payload: response.data });

        return response.data; //  Return the result to the component
    } catch (error) {
        dispatch({ type: "CHECK_EMAIL_FAIL", payload: error.message });

        return { error: error.message }; //  Return the error so the component
    }
};


const reactivatingAccount = (id) => {
    const URL = API_HOST + API.auth.reactivate + id;
    return async (dispatch) => {
        axios
            .get(URL)
            .then((res) => {
                dispatch(reactivateAccount(res.data));
            })
            .catch((err) => console.log(err));
    };
};

const login = (data, history, identity) => {
    try {
        const URL = API_HOST + API.auth.login;
        data.is_candidate = identity === 0;

        return async (dispatch) => {
            axios.post(URL, data).then(
                (res) => {
                    if (res.status === 200) {
                        setToken(res.data.token);
                        setRefreshToken(res.data.refresh_token);
                        setUserRole(getUser(res.data.token).roles[0]);
                        dispatch(loginSuccess(res.data.token));

                        // identity === 0 give candidate
                        switch (identity) {
                            case 0:
                                switch (getLoginStatus()) {
                                    case '204':
                                        dispatch(reactivatingAccount(getUserId()));
                                        dispatch(
                                            displaySecurityModal({
                                                status: 'REACTIVATE_ACCOUNT',
                                                modalType: 'success',
                                                statusCode: 200,
                                                modalTitle: 'reactivate_account',
                                            }),
                                        );
                                        setUserRole(getUser(res.data.token).roles[0]);
                                        break;
                                    case '409':
                                        removeToken();
                                        dispatch(
                                            displaySecurityModal({
                                                status: 'ACCOUNT_DISABLED_BY_AGENCY',
                                                modalType: 'warning',
                                                statusCode: 200,
                                                modalTitle: 'deactivate_account',
                                            }),
                                        );
                                        break;
                                    case !isCandidate():
                                        dispatch(
                                            displaySecurityModal({
                                                status: 'WRONG_ACCOUNT_TYPE',
                                                modalType: 'warning',
                                                statusCode: 200,
                                            }),
                                        );
                                        break;
                                    default:
                                        history.push('/tableau-de-bord');
                                        break;
                                }
                                break;
                            case 1:
                                switch (getUser().verified) {
                                    case true:
                                        switch (getUserRoleLevel()) {
                                            case 'ADMIN_CONSULTANT':
                                                history.push('/tableau-bord-agence');
                                                break;
                                            case 'MANAGER_CLIENT':
                                                history.push('/creer-une-annonce');
                                                break;
                                            default:
                                                dispatch(
                                                    displaySecurityModal({
                                                        status: 'WRONG_ACCOUNT_TYPE',
                                                        modalType: 'warning',
                                                        statusCode: 200,
                                                    }),
                                                );
                                                removeToken();
                                                break;
                                        }
                                        break;
                                    case false:
                                        dispatch(
                                            displaySecurityModal({
                                                status: 'AGENCY_NOT_VERIFIED_ACCOUNT',
                                                modalType: 'warning',
                                                statusCode: 200,
                                                modalTitle: 'agency_not_verified_account_title',
                                            }),
                                        );
                                        removeToken();
                                }
                                break;
                            default:
                                dispatch(
                                    displaySecurityModal({
                                        status: 'WRONG_ACCOUNT_TYPE',
                                        modalType: 'warning',
                                        statusCode: 200,
                                    }),
                                );
                                break;
                        }
                    }
                },
                (err) => {
                    dispatch(
                        displaySecurityModal({
                            status: err.response.data.status,
                            modalType: 'error',
                            statusCode: err.response.data.status_code,
                            userEmail: data.email,
                        }),
                    );
                },
            );
        };
    } catch (err) {
        console.log('err', err);
    }
};

const checkEmailState = (data, setModalOldCandidate, setLink) => {
    const URL = API_HOST + API.auth.checkEmailState;
    return async (dispatch) => {
        axios.post(URL, data).then(
            (res) => {
                setLink(res.data.url);
                setModalOldCandidate(true);
            },
            (err) => {
                console.log('err', err);
            },
        );
    };
};

const loginWithSocial = (data, history, identity) => {
    const URL = API_HOST + API.auth.socialLogin;
    return async (dispatch) => {
        axios.post(URL, data).then(
            (res) => {
                if (res.status === 200) {
                    setToken(res.data.token);
                    setRefreshToken(res.data.refresh_token);
                    setUserRole(getUser(res.data.token).roles[0]);
                    dispatch(loginSuccess(res.data.token));
                    if (getUser().verified) {
                        if (identity === 0 && isCandidate()) {
                            if (getLoginStatus() === '204') {
                                dispatch(
                                    isAccountDisabled({
                                        type: 'personal',
                                        title: 'reactivate_account',
                                        message: 'subtitle_reactivate_account',
                                    }),
                                );
                                dispatch(reactivatingAccount(getUserId()));
                                setUserRole(getUser(res.data.token).roles[0]);
                            } else if (getLoginStatus() === '409') {
                                removeToken();
                                dispatch(
                                    isAccountDisabled({
                                        type: 'recruiter',
                                        title: 'deactivated_account',
                                        message: 'subtitle_deactivate_account',
                                    }),
                                );
                            } else {
                                history.push('/tableau-de-bord');
                            }
                        } else if (identity === 0 && !isCandidate()) {
                            dispatch(alert({ msg: 'verified_account', type: 'warning' }));
                            removeToken();
                        } else if ((identity === 1 && isAdmin()) || (identity === 1 && isConsultant())) {
                            history.push('/tableau-bord-agence');
                        } else if ((identity === 1 && isManager()) || (identity === 1 && isClient())) {
                            history.push('/creer-une-annonce');
                        } else if (identity === 1 && !isClient() && !isConsultant() && !isAdmin() && !isManager()) {
                            dispatch(alert({ msg: 'verified_account', type: 'warning' }));
                            removeToken();
                        }
                    } else {
                        dispatch(
                            alert({
                                msg: 'not_verified_account',
                                type: 'warning',
                                actionButtons: [
                                    {
                                        name: 'verif_request',
                                        action: () => {
                                            dispatch(emailVerification(jwtDecode(res.data.token).username));
                                        },
                                    },
                                ],
                            }),
                        );
                        removeToken();
                    }
                } else {
                    dispatch(alert({ msg: 'invalid_credential', type: 'error' }));
                    removeToken();
                }
            },
            (err) => {
                if (err.response.data.includes("Utilisateur non trouvé pour l'adresse e-mail")) {
                    dispatch(
                        alert({
                            title: 'unsaved_mail_title',
                            msg: 'unsaved_mail_subtitle',
                            type: 'error',
                        }),
                    );
                }
            },
        );
    };
};

const LinkedInLogin = (access_token, history, identity) => {
    const URL = API_HOST + API.auth.loginLinkedIn;
    return async (dispatch) => {
        axios.get(URL, { params: { access_token } }).then((res) => {
            dispatch(loginWithSocial({ email: res.data.email }, history, identity));
        });
    };
};

const forgetPassword = (local, data) => {
    const URL = API_HOST + API.auth.forgetPassword;
    return async (dispatch) => {
        axios.post(URL, data, { params: local }).then(
            (res) => {
                if (res.data.code === 200) {
                    dispatch(alert({ msg: 'success_send_mail_reset_pwd', type: 'success' }));
                    dispatch(forgetPasswordAction(res.data));
                }
            },
            (error) => {
                if (error.response.status === 404) {
                    dispatch(alert({ msg: 'email_not_exist', type: 'error' }));
                }
            },
        );
    };
};

const resetPassword = (data, token) => {
    const URL = API_HOST + API.auth.resetPassword + `/${token}`;
    return async (dispatch) => {
        axios.post(URL, data).then((res) => {
            if (res.status === 200 && res.data.success === 'password has been updated') {
                dispatch(
                    alert({
                        msg: 'reset_password_saccess_title',
                        type: 'success',
                        redirectLink: 'return',
                    }),
                );
                dispatch(resetPasswordAction(res.data));
            } else {
                dispatch(alert({ msg: 'echec_update_pwd', type: 'error' }));
            }
        });
    };
};

const getSectors = (dataLocal) => {
    const URL = API_HOST + API.auth.sectors;
    let data = [];
    return async (dispatch) => {
        axios.post(URL, {}, { params: dataLocal }).then((res) => {
            // res.data.map((el) => {
            //     data.push({
            //         value: el.id,
            //         label: el.name,
            //     });
            // });
            dispatch(sectors(res.data));
        });
    };
};

const getProfessions = (dataLocal) => {
    const URL = API_HOST + API.auth.professions;
    let data = [];
    return async (dispatch) => {
        axios.post(URL, {}, { params: dataLocal }).then((res) => {
            res.data.map((el) => {
                data.push({
                    value: el.id,
                    label: el.name,
                });
            });
            dispatch(professions(data));
        });
    };
};

const getJobsTypes = (dataLocal) => {
    const URL = API_HOST + API.auth.jobtypes;
    let data = [];
    return async (dispatch) => {
        axios.get(URL, { params: dataLocal }).then((res) => {
            res.data.map((el) => {
                data.push({
                    id: el.id,
                    value: el.id,
                    label: el.name,
                    name: el.name,
                    checked: false,
                });
            });
            dispatch(jobsTypes(data));
        });
    };
};

const getNationalities = (dataLocal) => {
    const URL = API_HOST + API.auth.nationalities;
    let data = [];
    return async (dispatch) => {
        axios.get(URL, { params: dataLocal }).then((res) => {
            res.data.map((el) => {
                data.push({
                    value: el.id,
                    label: el.name,
                    code: el.code,
                });
            });
            dispatch(nationalities(data));
        });
    };
};

const getLocations = (dataLocal) => {
    const URL = API_HOST + API.auth.locations;
    return async (dispatch) => {
        axios.get(URL, { params: dataLocal }).then((res) => {
            dispatch(locations(res.data));
        });
    };
};

const getLocationsProfile = () => {
    const URL = API_HOST + API.auth.locations;
    return async (dispatch) => {
        axios.get(URL).then((res) => {
            dispatch(locations(res.data));
        });
    };
};

const getWorkingPermissions = (dataLocal) => {
    const URL = API_HOST + API.auth.workingpermissions;
    let data = [];
    return async (dispatch) => {
        axios.get(URL, { params: dataLocal }).then((res) => {
            res.data.map((el) => {
                data.push({
                    id: el.id,
                    value: el.id,
                    label: el.description,
                    name: el.name,
                });
            });
            dispatch(workingPermission(data));
        });
    };
};

const getListAgences = (data, page) => {
    const URL = API_HOST + API.auth.listAgences;
    return async (dispatch) => {
        axios.post(URL, data, { params: page }).then((res) => {
            dispatch(agencesList(res.data));
        });
    };
};

const logOut = () => {
    removeToken();
    window.location.assign('/');
};

const registerAgency = (data) => {
    const URL = API_HOST + API.auth.registerAgency;
    return async (dispatch) => {
        axios.post(URL, data).then(
            (res) => {
                if (res.data.code === 200) {
                    dispatch(
                        alert({
                            msg: 'success_register_user',
                            redirectLink: 'return_login_page',
                            type: 'success',
                        }),
                    );
                } else if (res.data.code === 400) {
                    dispatch(alert({ msg: 'email_exist', type: 'error' }));
                }
            },
            (err) => {
                dispatch(alert({ msg: 'error_register', type: 'error' }));
            },
        );
    };
};

const loginPostulation = (data, idMission, title) => {
    try {
        const URL = API_HOST + API.auth.login;
        return async (dispatch) => {
            axios.post(URL, data).then(
                (res) => {
                    if (res.status === 200) {
                        setToken(res.data.token);
                        setRefreshToken(res.data.refresh_token);
                        setUserRole(getUser(res.data.token).roles[0]);
                        dispatch(loginSuccess(res.data.token));
                        dispatch(applyMissionPostulation({ missionId: idMission }, title));
                    }
                },
                (err) => {
                    dispatch(alert({ msg: 'invalid_credential', type: 'error' }));
                },
            );
        };
    } catch (err) {
        console.log('err', err);
    }
};

const emailVerification = (data) => {
    try {
        const URL = API_HOST + API.auth.emailVerification;
        return async (dispatch) => {
            axios.post(URL, { email: data }).then(
                (res) => {
                    if (res.status === 200) {
                        dispatch(alert({ msg: 'verified_account', type: 'success' }));
                    }
                },
                (err) => {
                    dispatch(alert({ msg: 'not_verified_account', type: 'error' }));
                },
            );
        };
    } catch (err) {
        console.log('err', err);
    }
};

// this using redux thunk
const sendEmailVerificationAccount = (email) => async () => {
    const URL = API_HOST + API.auth.emailVerification;
    try {
        await axios.post(URL, { email });
        return true;
    } catch (err) {
        return false;
    }
};

export {
    loginPostulation,
    reactivatingAccount,
    setUserType,
    register,
    checkExistMail,
    login,
    checkEmailState,
    loginWithSocial,
    getLocationsProfile,
    forgetPassword,
    resetPassword,
    getSectors,
    getProfessions,
    getJobsTypes,
    getNationalities,
    getLocations,
    getWorkingPermissions,
    getListAgences,
    logOut,
    registerAgency,
    LinkedInLogin,
    emailVerification,
    sendEmailVerificationAccount,
    checkEmail,
};
